import Backbone from 'backbone';
import ko from 'knockout';
import $ from 'jquery';
import _ from 'underscore';
import Viewmodel from './multilevel-dropdown-viewmodel';
import template from './multilevel-dropdown-template.pug';
import newItemTemplate from './multilevel-dropdown-newitem-template.pug';

function construct(root, data) {
  if (!root) {
    throw new Error('Root ul element cannot be null when append new menu item.');
  }

  if (data.length === 0) {
    throw new Error('Debug menu sub-menu name cannot be null.');
  }

  root.append(newItemTemplate({
    data,
    isMultiSelect: this.isMultiSelect,
    customTemplate: this.customTemplate,
  }));
}

function searchChildren(data) {
  if (data.view) {
    /* eslint-disable no-unused-vars */
    /* eslint-disable new-cap */
    const view = new data.view({
      element: `.sc-dropdown-${data.value}`,
      data: _.omit(data, 'parent', 'showChildren', 'selected', 'view'),
    });
  }
  if (data.children && data.children.length > 0) {
    searchChildren(data.children);
  }
}

function select(event) {
  const target = $(event.currentTarget);
  if (!target.find('.dropdown-menuitem').hasClass('disabled')) {
    this.viewModel.select($(event.currentTarget).data('value'));
  }

  event.stopPropagation();
}

function showSubmenu(event) {
  const target = $(event.currentTarget);
  const value = target.parent().data('value');

  this.viewModel.showSubmenu(value, target);
  target.parent().find('.dropdown-menu').css('top', target.position().top);
}

function toggleMultiSelectView(event) {
  if (this.isMultiSelect) {
    const target = $(event.currentTarget).parent();
    if (target.hasClass('open')) {
      target.removeClass('open');
    } else {
      target.addClass('open');
    }
  }
}

export function hideOnClickOutside(parentElem, selectedElem) {
  const outsideClickListener = (event) => {
    if (!$.contains(parentElem, event.target)) {
      const dropdownDom = $(selectedElem).parents('.multilevel-dropdown');
      if ($(selectedElem).is(':visible') && dropdownDom.hasClass('open')) {
        dropdownDom.removeClass('open');
      }
    }
  };

  document.addEventListener('click', outsideClickListener);
}

/**
 * Generic Multi level dropdown which can be used across bingads platform.
 */
export class MultilevelDropdown extends Backbone.View {
  /**
   * Initializes a Multi level dropdown
   * @param {array} data - data to be shown in the dropdown. data object will
   * need to follow below format
   * [{
   *   children: null,
   *   text: 'display value 1',
   *   value: 'val1'
   * }, {
   *   children: {
   *   children: null,
   *   text: 'display value 2.1',
   *   value: 'val2.1'
   *   },
   *   text: 'display value2',
   *   value: 'value2'
   * }]
   * each object may contain the following properties which this control understands:
   * @param {bool} data.disabled : the entry with "disabled": true property will have "disabled"
   * class attached.
   * @param {bool} data.divider : the entry with "divider": true property will get a divider
   * underneath
   * current object.
   * @param {object} data.view : User may attach Backbone view inside the object in case they
   * want to have custom control within the dropdown
   * @param {string} preset - the default value of dropdown. This value must
   * match one of the "value" properties
   * in data object passed above. If not found, it will throw an exception
   * @param {object} customTemplate - custom template which will be applied across all options
   * @param {object} customSelectedTemplate - custom template to show what has been selected
   * @param {bool} isMultiSelect - If this property is true, the control will allow user to
   * @param {bool} disableParentClick - If this property is true, parent element click will not
   * trigger any action.
   * @returns {object} Returns backbone view
  */
  initialize({
    data,
    preset,
    customTemplate,
    customSelectedTemplate,
    isMultiSelect,
    disableParentClick,
    defaultBlankMenuText,
  }) {
    this.viewModel = new Viewmodel({
      data,
      preset,
      customTemplate,
      customSelectedTemplate,
      isMultiSelect,
      disableParentClick,
      defaultBlankMenuText,
    });

    this.data = data;
    this.customTemplate = customTemplate;
    this.customSelectedTemplate = customSelectedTemplate;
    this.isMultiSelect = isMultiSelect;
    this.defaultBlankMenuText = defaultBlankMenuText;
    this.viewModel.currentSelection.subscribe((item) => {
      this.trigger('selected', item);
      if (this.customSelectedTemplate) {
        this.$el.find('.dropdown-container').html(this.customSelectedTemplate(item));
      }
    });

    return this;
  }

  /**
   * Updates an object within data
   * @param {number} value - (required) Existing value inside current data object
   * @param {object} object - (required) An object which will replace the data node.
   *  Possibly properties can be: hide, text, divider, disabled
   *
   * @returns {void} Returns void
   */
  update(value, object) {
    if (!value || !object) {
      throw new Error('Both parameters are required!');
    }

    const node = this.viewModel.update(value, object);
    this.$el.find(`li[data-value='${value}']`).replaceWith(newItemTemplate({
      data: [node],
      isMultiSelect: this.isMultiSelect,
      customTemplate: this.customTemplate,
    }));
    ko.cleanNode(this.el);
    ko.applyBindings(this.viewModel, this.el);
  }

  /**
   * Add a dropdown node under node with parentValue. If parentValue is null,
   * it will be added under root.
   * @param {number} parentValue - (optional) value of parent object which the node
   * will be located
   * @param {object} object - (required) data node which will contain properties like
   * hide, text, divider, or disabled
   *
   * @returns {void} Returns void
   */
  add(parentValue, object) {
    if (!object) {
      throw new Error('Second parameter is required!');
    }

    this.viewModel.add(parentValue, object);
    const obj = object;
    obj.parent = ko.observable();
    obj.showChildren = ko.observable(false);
    obj.selected = ko.observable(false);

    if (parentValue) {
      const node = this.viewModel.findNode(this.data, parentValue);
      this.$el.find(`li[data-value='${parentValue}']`).replaceWith(newItemTemplate({
        data: [node],
        isMultiSelect: this.isMultiSelect,
        customTemplate: this.customTemplate,
      }));
    } else {
      $(this.$el.find('ul.dropdown-menu')[0]).append(newItemTemplate({
        data: [obj],
        isMultiSelect: this.isMultiSelect,
        customTemplate: this.customTemplate,
      }));
    }
    ko.cleanNode(this.el);
    ko.applyBindings(this.viewModel, this.el);
  }

  /**
   * Deletes a data node with provided value
   * @param {number} value - (required) value of node to be deleted
   *
   * @returns {void} Returns void
   */
  delete(value) {
    if (!value) {
      throw new Error('value is required!');
    }

    this.viewModel.delete(value);
    this.$el.find(`li[data-value='${value}']`).remove();
  }

  /**
   * Renders dropdown view
   * @param {string} parent - (required) jquery element string
   *
   * @returns {object} the backbone view
   */
  render(parent) {
    this.$el.html(template({
      isMultiSelect: this.isMultiSelect,
      defaultBlankMenuText: this.defaultBlankMenuText,
    }));
    hideOnClickOutside(this.el, this.$el.find('.first-dropdown-submenu')[0]);
    construct.call(this, this.$el.find('.dropdown-menu'), this.viewModel.data);
    this.viewModel.triggerPresetValue();
    ko.cleanNode(this.el);
    ko.applyBindings(this.viewModel, this.el);
    $(parent).append(this.$el);
    _.each(this.viewModel.data, (dataObj) => {
      searchChildren(dataObj);
    });

    return this;
  }

  get events() {
    return {
      'click .btn-apply': select,
      'mouseover .dropdown-menuitem': showSubmenu,
      'click .dropdown-container': toggleMultiSelectView,
    };
  }
}
